var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page, ComponentInstances } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
var EmptyGuid = "00000000-0000-0000-0000-000000000000";
import "../../components/header";
import "../../components/leftMenu";
import "./system.css";
import * as authorization from "../../lib/authorization";
import * as ajax from "../../app-lib/ajax_proxy";
import "../../components/paging";
import "../../components/tree";
import { Configs } from '../../app-lib/constants';
import '../../lib/knockout_fileUpload';
import "../../components/paging";
import '../../lib/knockout_datePicker';
// import * as jscolor from '../../assets/js/jscolor.js';
var SystemsetupModel = /** @class */ (function (_super) {
    __extends(SystemsetupModel, _super);
    function SystemsetupModel(root) {
        var _this = _super.call(this, "", root, {}) || this;
        _this.xitong = ko.observable(1);
        _this.renyuan = ko.observable(0);
        _this.weihu = ko.observable(0);
        _this.yonghu = ko.observable(0);
        _this.fenzu = ko.observable(0);
        _this.zuzhi = ko.observable(0); //组织架构
        _this.tips = ko.observable(0); //类型管理
        _this.Lable = ko.observable(0); //标签维护
        _this.isShowPerformance = ko.observable(false); //目标值
        return _this;
    }
    SystemsetupModel.prototype.RenYuan = function () {
        if (this.renyuan() == 1) {
            this.renyuan(0);
        }
        else {
            this.renyuan(1);
        }
    };
    //系统日志
    SystemsetupModel.prototype.XiTong = function () {
        var element = event.srcElement;
        var nodelist = this.container.querySelectorAll(".file-left-center-line");
        for (var i = 0; i < nodelist.length; i++) {
            nodelist[i].setAttribute("style", "background-color:white");
        }
        //debugger;
        // console.log("----------系统日志-------------");
        element.setAttribute("style", "background-color:#cde3f7");
        this.xitong(1);
        this.weihu(0);
        this.yonghu(0);
        this.fenzu(0);
        this.zuzhi(0);
        this.tips(0);
        this.Lable(0);
        ko.postbox.publish("xitong", "1");
    };
    //类型维护
    SystemsetupModel.prototype.WeiHu = function () {
        var element = event.srcElement;
        var nodelist = this.container.querySelectorAll(".file-left-center-line");
        for (var i = 0; i < nodelist.length; i++) {
            nodelist[i].setAttribute("style", "background-color:white");
        }
        element.setAttribute("style", "background-color:#cde3f7");
        //console.log("----------类型维护-------------");
        this.xitong(0);
        this.weihu(1);
        this.yonghu(0);
        this.fenzu(0);
        this.zuzhi(0);
        this.tips(0);
        this.Lable(0);
        ko.postbox.publish("weihu", "1");
    };
    ///用户管理
    SystemsetupModel.prototype.YongHu = function () {
        var element = event.srcElement;
        var nodelist = this.container.querySelectorAll(".file-left-center-line");
        for (var i = 0; i < nodelist.length; i++) {
            nodelist[i].setAttribute("style", "background-color:white");
        }
        element.setAttribute("style", "background-color:#cde3f7");
        // console.log("----------用户管理-------------");
        this.xitong(0);
        this.weihu(0);
        this.yonghu(1);
        this.fenzu(0);
        this.zuzhi(0);
        this.tips(0);
        this.Lable(0);
        ko.postbox.publish("yonghu", "1");
    };
    //分组管理
    SystemsetupModel.prototype.FenZu = function () {
        var element = event.srcElement;
        var nodelist = this.container.querySelectorAll(".file-left-center-line");
        for (var i = 0; i < nodelist.length; i++) {
            nodelist[i].setAttribute("style", "background-color:white");
        }
        element.setAttribute("style", "background-color:#cde3f7");
        this.xitong(0);
        this.weihu(0);
        this.yonghu(0);
        this.fenzu(1);
        this.zuzhi(0);
        this.tips(0);
        this.Lable(0);
        ko.postbox.publish("fenzu", "1");
    };
    //组织架构加载大区
    SystemsetupModel.prototype.ZuZhi = function (e, index) {
        //光标选定
        var element = event.srcElement;
        var nodelist = this.container.querySelectorAll(".file-left-center-line");
        for (var i = 0; i < nodelist.length; i++) {
            nodelist[i].setAttribute("style", "background-color:white");
        }
        element.setAttribute("style", "background-color:#cde3f7");
        this.xitong(0);
        this.weihu(0);
        this.yonghu(0);
        this.fenzu(0);
        this.zuzhi(1);
        this.tips(0);
        this.Lable(0);
        ko.postbox.publish("jiagou", "1");
    };
    //提醒类型设置
    SystemsetupModel.prototype.tipType = function (e, index) {
        //光标选定
        var element = event.srcElement;
        var nodelist = this.container.querySelectorAll(".file-left-center-line");
        for (var i = 0; i < nodelist.length; i++) {
            nodelist[i].setAttribute("style", "background-color:white");
        }
        element.setAttribute("style", "background-color:#cde3f7");
        this.xitong(0);
        this.weihu(0);
        this.yonghu(0);
        this.fenzu(0);
        this.zuzhi(0);
        this.tips(1);
        this.Lable(0);
        ko.postbox.publish("tipsType", "1");
    };
    //标签维护
    SystemsetupModel.prototype.labelMaintenance = function (e, index) {
        //光标选定
        var element = event.srcElement;
        var nodelist = this.container.querySelectorAll(".file-left-center-line");
        for (var i = 0; i < nodelist.length; i++) {
            nodelist[i].setAttribute("style", "background-color:white");
        }
        element.setAttribute("style", "background-color:#cde3f7");
        this.xitong(0);
        this.weihu(0);
        this.yonghu(0);
        this.fenzu(0);
        this.zuzhi(0);
        this.tips(0);
        this.Lable(1);
        ko.postbox.publish("labelMaintenance", "1");
    };
    return SystemsetupModel;
}(KnockoutModel));
var LogModel = /** @class */ (function (_super) {
    __extends(LogModel, _super);
    function LogModel(root) {
        var _this = _super.call(this, "/api/logs", root, {
            pageIndex: 1,
            condition: "",
            type: 0,
        }) || this;
        _this.selectlog = ko.observable(); //搜索条件
        ko.postbox.subscribe('xitong', function (n) {
            _this.data.pageIndex = 1;
            _this.data.condition = "";
            _this.data.type = 0;
            _this.loadData();
            _this.selectlog("");
        });
        return _this;
    }
    LogModel.prototype.Scortnew = function () {
        //从高到低
        this.data.pageIndex = this.viewModel().data.pageIndex;
        this.data.condition = this.selectlog();
        this.data.type = 1;
        this.loadData();
    };
    LogModel.prototype.Scortold = function () {
        //从低到高
        this.data.pageIndex = this.viewModel().data.pageIndex;
        this.data.condition = this.selectlog();
        this.data.type = 0;
        this.loadData();
    };
    //点击筛选符合条件的日志
    LogModel.prototype.changeselect = function () {
        this.data.pageIndex = 1;
        this.data.condition = this.selectlog();
        this.loadData();
    };
    // chosenMonthData(data: any) {
    //   if (this.data.isChosen()) {
    //     this.data.isChosen(false);
    //     this.data.chosenData.splice(
    //       this.data.chosenData.indexOf(data.list[0]),
    //       data.list.length
    //     );
    //   } else {
    //     this.data.isChosen(true);
    //     this.data.chosenData(this.data.chosenData().concat(data.list));
    //   }
    //   return true;
    // }
    LogModel.prototype.loadbubble = function () {
        var arr = [];
        for (var i = 0; i < 7; i++) {
            arr.push(localStorage.getItem(i.toString()));
        }
        return ajax.post('/api/statistics/smessage', { userId: authorization.getUserId(), time: arr }).then(function (d) {
            ko.postbox.publish('leftMenu_myProject', d.data.count0);
            ko.postbox.publish('leftMenu_myFollowProject', d.data.count1);
            ko.postbox.publish('leftMenu_noFollowNews', d.data.count2);
            ko.postbox.publish('leftMenu_waitProjectNews', d.data.count3);
            ko.postbox.publish('leftMenu_signgedProjectNews', d.data.count4);
            ko.postbox.publish('leftMenu_abandonProjectNews', d.data.count5);
            ko.postbox.publish('leftMenu_auditMessage', d.data.count6);
        });
    };
    LogModel.prototype.loadnum = function () {
        return ajax.get('/api/statistics/message', { userid: authorization.getUserId(), loginTime: new Date()["Format"]('yyyy-MM-dd hh:mm:ss') }).then(function (d) {
            ko.postbox.publish('leftMenu_allProject', d.data.allProject);
            ko.postbox.publish('leftMenu_followProject', d.data.followProject);
            ko.postbox.publish('leftMenu_nofollow', d.data.nofollow);
            ko.postbox.publish('leftMenu_waitProject', d.data.waitProject);
            ko.postbox.publish('leftMenu_signgedProject', d.data.signgedProject);
            ko.postbox.publish('leftMenu_abandonProject', d.data.abandonProject);
            ko.postbox.publish('leftMenu_noReadProject', d.data.noReadProject);
        });
    };
    LogModel.prototype.load = function () {
        return Promise.all([this.loadnum(), this.loadData()]).then(function () { });
    };
    return LogModel;
}(KnockoutModel));
var TypeModel = /** @class */ (function (_super) {
    __extends(TypeModel, _super);
    function TypeModel(root) {
        var _this = _super.call(this, "/api/type/goal", root, {}) || this;
        _this.guanli = ko.observable(0);
        _this.shezhi = ko.observable(1);
        _this.popur = ko.observable(0);
        _this.newDataTypeName = ko.observable('');
        _this.newDataTypeMessage = ko.observable('');
        _this.addDataTypeName = ko.observable('');
        _this.addDataTypeMessage = ko.observable('');
        _this.goal = ko.observable(); // 目标值
        _this.baifenbi = ko.observable(); // 百分比
        _this.yuan = ko.observable(); // 元
        _this.dataType = ko.observableArray([]);
        _this.popur2 = ko.observable(0);
        _this.dataTypeId = ko.observable();
        _this.isChange = ko.observable(false);
        _this.formulaData = ko.observable({
            beginTime: ko.observable(""),
            endTime: ko.observable(""),
            id: "",
            name: "",
            pro: 0,
            pur: 0,
            status: false
        });
        _this.isShowPerformance = ko.observable(false);
        _this.performanceArr = ko.observableArray([]);
        _this.addArea = ko.observable(''); //新增面积
        _this.addCount = ko.observable('');
        ko.postbox.subscribe("weihu", function (weihuvalue) {
            _this.loadData().then(function (d) {
                //this.dataType(d.data);
                // this.loadgoal();
            });
        });
        return _this;
    }
    TypeModel.prototype.Popur2 = function (id, index) {
        if (typeof index == 'number') {
            this.newDataTypeName(this.dataType()[index].typeTitle);
            this.newDataTypeMessage(this.dataType()[index].typeData);
            this.dataTypeId(id);
        }
        if (this.popur2() == 1) {
            this.popur2(0);
        }
        else {
            this.popur2(1);
        }
    };
    // 确定按钮
    TypeModel.prototype.Popur = function (m, e) {
        this.addDataTypeMessage('');
        this.addDataTypeName('');
        if (this.popur() == 1) {
            this.popur(0);
        }
        else {
            this.popur(1);
        }
    };
    // loadgoal(){
    //   ajax.get("/api/type/goal",{uid:'liu'}).then(d=>{
    //       this.yuan(d.data.money);
    //       this.baifenbi(d.data.percent);
    //       this.goal(d.data.year_goal);
    //   }).catch(e=>{
    //   });
    // }
    TypeModel.prototype.judge = function () {
        if (this.addArea() == '') {
            // window.popBox.show('面积不能为空');
            // this.getArea();
            return;
        }
        if (!this.numberOrNo(this.addArea())) {
            // window.popBox.show('只能输入数字');
            // this.getArea();
            // this.getArea();
            // this.addArea('')
            return;
        }
    };
    TypeModel.prototype.numberOrNo = function (val) {
        var regPos = /^\d+(\.\d+)?$/; //非负浮点数
        var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
        if (regPos.test(val) || regNeg.test(val)) {
            return true;
        }
        else {
            return false;
        }
    };
    TypeModel.prototype.getArea = function () {
        var _this = this;
        ajax.get('/api/system/result', {}).then(function (d) {
            _this.addArea(d.data.result);
            _this.addCount(d.data.projectCount);
            // console.log(this.addArea())
        });
    };
    // /提交新增面积
    TypeModel.prototype.addareaButton = function () {
        if (this.addArea() == '') {
            window.popBox.show('面积不能为空');
            return;
        }
        if (parseInt(this.addArea()) > 99999999999999) {
            window.popBox.show('面积过大');
            return;
        }
        console.log(this.addArea());
        if (!this.numberOrNo(this.addArea())) {
            window.popBox.show('只能输入数字');
            // this.addArea('');
            // this.getArea();
            this.addArea('');
            return;
        }
        if (isNaN(parseInt(this.addCount()))) {
            return window.popBox.show('项目个数不能为空');
        }
        ajax.post('/api/system/result', {
            userId: authorization.getUserId(),
            result: this.addArea(),
            projectCount: this.addCount()
        }).then(function (d) {
            if (d) {
                window.popBox.show('添加成功');
            }
            else {
                window.popBox.show('添加失败');
            }
        });
    };
    TypeModel.prototype.lookPM = function () {
        console.log(0);
        this.isShowPerformance(!this.isShowPerformance());
        if (this.chooseType) {
            this.chooseType(this.isShowPerformance());
        }
    };
    TypeModel.prototype.closePM = function () {
        this.isShowPerformance(false);
    };
    TypeModel.prototype.save = function () {
        var _this = this;
        console.log(this.formulaData());
        if (this.formulaData().name.trim() == '') {
            console.log(this.formulaData());
            return window.popBox.show('公式名字不能为空');
        }
        if (this.formulaData().name.trim().length > 20) {
            return window.popBox.show('公式名字过长');
        }
        if (this.formulaData().beginTime() == '') {
            return window.popBox.show('请选择一个开始生效时间');
        }
        if (this.formulaData().endTime) {
            var startyear = parseInt(this.formulaData().beginTime().split('-')[0]);
            var endyear = parseInt(this.formulaData().endTime().split('-')[0]);
            var startmonth = parseInt(this.formulaData().beginTime().split('-')[1]);
            var endmonth = parseInt(this.formulaData().endTime().split('-')[1]);
            var startday = parseInt(this.formulaData().beginTime().split('-')[2]);
            var endday = parseInt(this.formulaData().endTime().split('-')[2]);
            if (startyear > endyear) {
                return window.popBox.show('开始时间不能大于结束时间');
            }
            else if (startyear == endyear) {
                if (startmonth > endmonth) {
                    return window.popBox.show('开始时间不能大于结束时间');
                }
                else if (startmonth == endmonth) {
                    if (startday >= endday) {
                        return window.popBox.show('开始时间不能大于(或等于)结束时间');
                    }
                }
            }
        }
        else {
            return window.popBox.show('结束时间不能为空');
        }
        if (Number(this.formulaData().pur) == 0) {
            return window.popBox.show('全委不能为0%');
        }
        if (Number(this.formulaData().pur) > 100) {
            console.log(this.formulaData());
            return window.popBox.show('全委不能超过100%');
        }
        if ((Number(this.formulaData().pro) == 0)) {
            return window.popBox.show('收购价格不能为0');
        }
        if (parseInt(this.formulaData().pro) > 1000000000) {
            console.log(this.formulaData());
            return window.popBox.show('收购价格超出最大限度');
        }
        this.saveData(this.toJS(this.formulaData())).then(function (d) {
            window.popBox.show(d.message);
            _this.popur(0);
            _this.loadData();
        });
    };
    TypeModel.prototype.addData = function () {
        this.formulaData({
            beginTime: ko.observable(''),
            endTime: ko.observable(''),
            id: "",
            name: "",
            pro: 0,
            pur: 0,
            status: false
        });
        this.isChange(false);
        this.popur(1);
    };
    TypeModel.prototype.dataChange = function (data) {
        data.beginTime = ko.observable(data.beginTime);
        data.endTime = ko.observable(data.endTime);
        this.formulaData(data);
        this.isChange(true);
        this.popur(1);
    };
    TypeModel.prototype.statusChange = function (data) {
        var _this = this;
        ajax.put('/api/type/status', {
            id: data.id,
            status: (data.status ? 1 : 0)
        }).then(function (d) {
            window.popBox.show(d.message);
            _this.loadData();
        });
    };
    TypeModel.prototype.timecut = function (time) {
        if (time) {
            return time.split('T')[0];
        }
    };
    TypeModel.prototype.SheZhi = function (m, e) {
        this.loadData();
        var div = e.currentTarget;
        div.classList.add("active");
        div.previousElementSibling.classList.remove("active");
        this.shezhi(1);
        this.guanli(0);
    };
    TypeModel.prototype.sure = function () {
        var reg = /^\d+(\.\d+)?$/;
        var reg2 = /^[0]{2,3}/;
        if (reg2.test(this.goal()) || !reg.test(this.goal())) {
            window.popBox.show("目标值不合法");
            return;
        }
        if (reg2.test(this.baifenbi()) || !reg.test(this.baifenbi()) || parseInt(this.baifenbi()) > 100) {
            window.popBox.show("输入的百分比不合法");
            return;
        }
        if (reg2.test(this.yuan()) || !reg.test(this.yuan())) {
            window.popBox.show("总合约面积输入金额不合法");
            return;
        }
        ajax.post("/api/type/goal", { uid: 'liu', percent: this.baifenbi(), money: this.yuan(), performanceGoal: this.goal() })
            .then(function (d) {
            if (d.status == '0') {
                window.popBox.show("设置成功");
            }
        }).catch(function (e) {
            window.popBox.show("错误");
        });
    };
    TypeModel.prototype.GuanLi = function (m, e) {
        var div = e.currentTarget;
        div.classList.add("active");
        div.nextElementSibling.classList.remove("active");
        this.shezhi(0);
        this.guanli(1);
    };
    TypeModel.prototype.WeiHu = function () {
        var _this = this;
        ajax.get("/api/data/type")
            .then(function (d) {
            _this.dataType(d.data);
        });
    };
    ////// 删除类型 authour liu
    TypeModel.prototype.deleteType = function (id) {
        var _this = this;
        var flag = confirm("确认删除？");
        if (flag) {
            ajax.deleteIt("/api/data/type/" + id)
                .then(function (d) {
                ajax.get("/api/data/type").then(function (d) {
                    _this.dataType(d.data);
                });
                window.popBox.show("删除成功");
            })
                .catch(function (e) {
                window.popBox.show("删除失败");
            });
        }
    };
    // 修改类型
    TypeModel.prototype.editType = function () {
        var _this = this;
        if (this.newDataTypeName().trim() == "" || this.newDataTypeName().length > 20) {
            window.popBox.show("未输入类型或输入类型内容过长！！");
            return;
        }
        // if(this.newDataTypeMessage().length>20){
        //   window.popBox.show("输入内容过长！！");
        //   return;
        // }
        ajax.put("/api/data/type/" + this.dataTypeId(), { name: this.newDataTypeName(), comment: this.newDataTypeMessage() })
            .then(function (d) {
            ajax.get("/api/data/type").then(function (d) {
                _this.dataType(d.data);
            });
        })
            .catch(function (e) {
            window.popBox.show("修改失败");
        });
        this.popur2(0);
    };
    // 新增类型
    TypeModel.prototype.addType = function () {
        var _this = this;
        if (this.addDataTypeName().trim() == "" || this.addDataTypeName().length > 20) {
            window.popBox.show("未输入类型或输入类型内容过长！！");
            return;
        }
        // if(this.addDataTypeMessage().length>20){
        //   window.popBox.show("输入内容过长！！");
        //   return;
        // }
        ajax.post("/api/data/type", { name: this.addDataTypeName(), comment: this.addDataTypeMessage() })
            .then(function (d) {
            ajax.get("/api/data/type").then(function (d) {
                _this.dataType(d.data);
            });
        })
            .catch(function (e) {
            window.popBox.show("新增失败");
        });
        this.popur(0);
    };
    TypeModel.prototype.onViewModelSetting = function (d) {
        this.yuan(d.data.money);
        this.baifenbi(d.data.percent);
        this.goal(d.data.year_goal);
        for (var i in d.data) {
            if (d.data[i].beginTime) {
                d.data[i].beginTime = d.data[i].beginTime.split('T')[0];
                d.data[i].endTime = d.data[i].endTime.split('T')[0];
            }
        }
        return Promise.resolve(false);
    };
    return TypeModel;
}(KnockoutModel));
var PerformanceModel = /** @class */ (function (_super) {
    __extends(PerformanceModel, _super);
    function PerformanceModel(root) {
        var _this = _super.call(this, '/api/type/excel', root, {}) || this;
        _this.roleArr = ko.observableArray([]);
        _this.monthArr = ko.observableArray([]);
        _this.roleId = ko.observable();
        _this.month = ko.observable();
        _this.loadurl = ko.observable('');
        _this.leadurl = ko.observable('/api/type/import');
        _this.isShowPerformance = ko.observable(false);
        _this.month.subscribe(function () {
            _this.data.year = _this.month();
            _this.data.roleId = _this.roleId();
            _this.data.pageIndex = 1;
            _this.loadData();
            console.log('month:' + _this.month());
        });
        _this.roleId.subscribe(function () {
            _this.data.year = _this.month();
            _this.data.roleId = _this.roleId();
            _this.data.pageIndex = 1;
            _this.loadData();
            console.log('roleId:' + _this.roleId());
        });
        return _this;
    }
    // 角色切换
    PerformanceModel.prototype.roleChange = function () {
        this.data.year = this.month();
        this.data.roleId = this.roleId();
        this.data.pageIndex = 1;
        this.loadData();
    };
    PerformanceModel.prototype.closeShowPerformance = function () {
        console.log(0);
        this.isShowPerformance(!this.isShowPerformance());
        if (this.chooseType) {
            this.chooseType(this.isShowPerformance());
        }
        return true;
    };
    PerformanceModel.prototype.downloadModel = function () {
        window.open(Configs.serviceUrl + '/api/type/download');
    };
    PerformanceModel.prototype.uploadsuccess = function (ds) {
        if (ds.status == '0') {
            this.data.year = '';
            this.data.roleId = '';
            this.data.pageIndex = 1;
            this.load();
        }
        window.popBox.show(ds.message);
    };
    //导出
    PerformanceModel.prototype.down = function () {
        console.log(this.month());
        console.log(this.roleId());
        if (this.month() && !this.roleId()) {
            window.open(Configs.serviceUrl + '/api/type/export?year=' + this.month());
        }
        else if (!this.month() && this.roleId()) {
            window.open(Configs.serviceUrl + '/api/type/export?roleId=' + this.roleId());
        }
        else if (this.month() && this.roleId()) {
            window.open(Configs.serviceUrl + '/api/type/export?year=' + this.month() + '&roleId=' + this.roleId());
        }
        else {
            window.open(Configs.serviceUrl + '/api/type/export');
        }
    };
    PerformanceModel.prototype.loadSearch = function () {
        var _this = this;
        return ajax.get('/api/type/screen', {}).then(function (d) {
            _this.roleArr(d.data.role);
            _this.monthArr(d.data.year);
        });
    };
    PerformanceModel.prototype.load = function () {
        this.reset();
        this.data.year = '';
        this.data.roleId = '';
        this.data.pageIndex = 1;
        return Promise.all([this.loadSearch(), this.loadData()]).then(function () { });
    };
    PerformanceModel.prototype.onViewModelSetting = function (r) {
        return Promise.resolve(false);
    };
    PerformanceModel.prototype.reset = function () {
        this.roleId(undefined);
        this.month(new Date().getFullYear());
    };
    return PerformanceModel;
}(KnockoutModel));
var ManagementModel = /** @class */ (function (_super) {
    __extends(ManagementModel, _super);
    function ManagementModel(root) {
        var _this = _super.call(this, "/api/user/all1", root, {}) || this;
        _this.drole = ko.observable(0);
        _this.postType = ko.observableArray(); //岗位下拉表
        _this.regionType = ko.observableArray(); //大区下拉表
        _this.usersrole = ko.observableArray(); //批量新增角色加载的所有角色下拉表
        _this.tUser = ko.observable(0); //
        _this.postAtr = ko.observable(); //岗位id
        _this.regionAtr = ko.observable(); //大区id
        _this.deleroleId = ko.observableArray(); //要删除的用户角色
        _this.selectuser = ko.observable(); //按条件查询用户输入框的值
        _this.Rolebtn = ko.observable(0);
        _this.choose_index = ko.observableArray(); //选中的用户
        _this.selectname = ko.observable(); //新增的角色名
        _this.userid = ko.observable(0); //要删除角色的用户id
        _this.delerolename = ko.observable(); //用户要删除的角色id
        _this.opvalue = ko.observable(); //用户状态值
        _this.departmentUrluser = ko.observable('/api/org/showdepa');
        _this.userlevel = ko.observable('');
        //========用户管理模块   批量操作用户角色
        //根据条件检索用户 selectuser
        // userchange() {
        //   this.data={}
        //   this.data.pageIndex=1;
        //   this.data.post=this.postAtr();
        //   this.data.region=this.regionAtr();
        //   this.data.condition=this.selectuser();
        //   this.loadData();
        // }
        _this.levelSelect = ko.observableArray([
            {
                id: '1',
                text: '1'
            }, {
                id: '2',
                text: '2'
            }, {
                id: '3',
                text: '3'
            }, {
                id: '4',
                text: '4'
            },
        ]);
        _this.deptid = ko.observableArray([]);
        _this.deptName = ko.observable();
        _this.isShowRegion = ko.observable(false);
        _this.AllCheck = ko.observableArray([]);
        ko.postbox.subscribe("yonghu", function (n) {
            _this.data.pageIndex = 1;
            //  this.data.post="";
            //  this.data.region="";
            //  this.data.condition="";
            _this.selectuser('');
            _this.deptid([]);
            _this.userlevel('');
            _this.data.level = _this.userlevel();
            _this.data.condition = _this.selectuser();
            _this.data.deptid = _this.deptid();
            _this.deptName(undefined);
            _this.regionType([{}]); //清空大区和岗位的搜索条件
            _this.loadData();
            if (_this.regionType()) {
                ajax.get("/api/regions", {}).then(function (d) {
                    _this.selectuser('');
                    _this.choose_index([]);
                    _this.regionType(d.data);
                });
            }
        });
        return _this;
    }
    ManagementModel.prototype.onFocus = function () {
        this.isShowRegion(true);
    };
    ManagementModel.prototype.maopao = function () {
    };
    ManagementModel.prototype.btndelte = function (e) {
        // 兼容ie11以下没有find方法
        //没有该方法时,自定义
        if (!Array.prototype.find) {
            Array.prototype.find = function (callback) {
                return callback && (this.filter(callback) || [])[0];
            };
        }
        if (e.keyCode == '8') {
            var index = this.deptName().lastIndexOf(',');
            var str_1 = this.deptName().substring(index + 1);
            this.deptName(this.deptName().substring(0, index));
            var data_1 = this.AllCheck().find(function (p) { return p.name == str_1; });
            var dd = this.deptid().findIndex(function (p) { return p == data_1.id; });
            if (this.deptid().findIndex(function (p) { return p == data_1.id; }) > -1) {
                this.deptid().splice(this.deptid().findIndex(function (p) { return p == data_1.id; }), 1);
            }
            if (this.AllCheck().findIndex(function (p) { return p.name == str_1; }) > -1) {
                this.AllCheck().splice(this.AllCheck().findIndex(function (p) { return p.name == str_1; }), 1);
            }
            console.log(this.deptid());
        }
    };
    ManagementModel.prototype.duble = function () {
        this.isShowRegion(false);
        return true;
    };
    ManagementModel.prototype.onUserOrgChange = function (data) {
        if (data.id != '0') {
            // let arr=(this.deptName()==undefined)?[]:this.deptName().split(',');
            // let index=this.deptid.indexOf(data.id);
            // if(index>-1){
            //   this.deptid.splice(index,1);
            //   arr.splice(index,1);
            // }else{
            //   arr.push(data.name);
            //   this.deptid.push(data.id);
            // }
            // if(arr.length==0){
            //   this.deptName(undefined);
            // }else{
            //   this.deptName(arr.join(','));
            // }
            // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
            if (data.id != '0') {
                if (this.deptid().findIndex(function (p) { return p == data.id; }) == -1) {
                    if (this.deptid().length == 0) {
                        this.deptName(data.name);
                    }
                    else {
                        this.deptName(this.deptName() + ',' + data.name);
                    }
                    this.deptid.push(data.id);
                    this.AllCheck.push(data);
                }
                else {
                    var arr = this.deptName() == undefined ? [] : this.deptName().split(',');
                    arr.splice(arr.findIndex(function (n) { return n == data.name; }), 1);
                    this.deptName(arr.join(','));
                    this.deptid().splice(this.deptid().findIndex(function (p) { return p == data.id; }), 1);
                    this.AllCheck().splice(this.AllCheck().findIndex(function (p) { return p.id == data.id; }), 1);
                }
                // console.log(this.deptid())
            }
        }
    };
    ManagementModel.prototype.startsearch = function () {
        this.data.pageIndex = 1,
            this.data.condition = this.selectuser(),
            this.data.level = this.userlevel(),
            this.data.deptid = this.deptid();
        this.loadData();
        // ajax.get('/api/user/all1',{
        // }).then((d:any)=>{
        //   this.viewModel(d)
        // })
    };
    ManagementModel.prototype.dengjichange = function () {
        this.data.pageIndex = 1;
        this.data.level = this.userlevel();
        this.data.condition = this.selectuser();
        this.data.deptid = this.deptid();
        this.loadData();
    };
    //根据岗位搜索
    // postchange() {
    //   this.data={}
    //   this.data.pageIndex=1;
    //   this.data.post=this.postAtr();
    //   this.data.region=this.regionAtr();
    //   this.data.condition=this.selectuser();
    //   this.loadData();
    // }
    //根据大区搜索
    // regionchange(m: any, e: any) {
    //   //console.log('---------大区id---------')
    //   //加载岗位
    //   ajax.get("/api/posts", { departmentId: this.regionAtr() }).then(d => {
    //     this.postType(d.data);
    //   });
    //   this.data={}
    //   this.data.pageIndex=1;
    //   this.data.post=this.postAtr();
    //   this.data.region=this.regionAtr();
    //   this.data.condition=this.selectuser();
    //   this.loadData();
    // }
    //批量新增角色取消
    ManagementModel.prototype.quxiao = function (m, e) {
        if (this.Rolebtn() == 1) {
            this.Rolebtn(0);
        }
        else {
            this.Rolebtn(1);
        }
    };
    //批量新增角色加载角色
    ManagementModel.prototype.Rolect = function (m, e, event) {
        var _this = this;
        //console.log(this.choose_index().length)
        if (this.choose_index().length == 0) {
            window.popBox.show("请至少勾选一栏！");
        }
        else {
            ajax.get("/api/role/all", {}).then(function (d) {
                _this.usersrole(d.data);
            });
            if (this.Rolebtn() == 1) {
                this.Rolebtn(0);
            }
            else {
                this.Rolebtn(1);
            }
        }
    };
    //批量新增角色
    ManagementModel.prototype.addRole = function (m, e) {
        var _this = this;
        if (this.Rolebtn() == 1) {
            this.Rolebtn(0);
        }
        else {
            this.Rolebtn(1);
        }
        ajax.post("/api/role", {
            pageIndex: this.viewModel().data.pageIndex,
            roleId: this.selectname(),
            userId: this.choose_index()
        }).then(function () {
            ajax.get("/api/user/all1", {
                pageIndex: _this.viewModel().data.pageIndex,
                post: _this.postAtr(),
                region: _this.regionAtr(),
                condition: _this.selectuser()
            }).then(function (d) {
                _this.viewModel(d);
                _this.choose_index([]);
            });
        });
    };
    //删除用户角色
    //删除角色按钮
    ManagementModel.prototype.droleid = function (data) {
        var _this = this;
        // console.log(data.roleName + "-------------用户角色------------------");
        console.log(data);
        if (data.roleName == "无" || data.roleName == "") {
            return window.popBox.show("暂无标签！");
        }
        else {
            this.userid(data.id);
            ajax.get("/api/role/userId", { userId: data.id }).then(function (d) {
                _this.deleroleId(d.data);
            });
            if (this.drole() == 1) {
                this.drole(0);
            }
            else {
                this.drole(1);
            }
        }
    };
    //确认删除角色
    ManagementModel.prototype.droles = function (aa, id) {
        var _this = this;
        ajax
            .deleteIt("/api/role", {
            roleId: this.delerolename(),
            userId: this.userid(),
        })
            .then(function () {
            ajax
                .get("/api/user/all1", {
                pageIndex: _this.viewModel().data.pageIndex,
                post: _this.postAtr(),
                region: _this.regionAtr(),
                condition: _this.selectuser()
            })
                .then(function (d) {
                _this.viewModel(d);
            });
        });
        if (this.drole() == 1) {
            this.drole(0);
        }
        else {
            this.drole(1);
        }
    };
    //取消删除
    ManagementModel.prototype.dro = function () {
        if (this.drole() == 1) {
            this.drole(0);
        }
        else {
            this.drole(1);
        }
    };
    //批量启停用户
    ManagementModel.prototype.stUser = function () {
        if (this.choose_index().length == 0) {
            window.popBox.show("请至少勾选一栏！");
        }
        else {
            if (this.tUser() == 1) {
                this.tUser(0);
            }
            else {
                this.tUser(1);
            }
        }
    };
    //批量启停用户提交
    ManagementModel.prototype.sureUser = function () {
        var _this = this;
        if (this.opvalue() == undefined) {
            window.popBox.show("请选择一个状态");
            return;
        }
        else {
            ajax.put("/api/user/state", {
                pageIndex: this.viewModel().data.pageIndex,
                userId: this.choose_index(),
                userState: this.opvalue()
            })
                .then(function () {
                ajax
                    .get("/api/user/all1", {
                    pageIndex: _this.viewModel().data.pageIndex,
                    post: _this.postAtr(),
                    region: _this.regionAtr(),
                    condition: _this.selectuser()
                })
                    .then(function (d) {
                    _this.viewModel(d);
                });
            });
        }
        if (this.tUser() == 1) {
            this.tUser(0);
        }
        else {
            this.tUser(1);
        }
    };
    //用户管理选中
    ManagementModel.prototype.btn_choose = function (res, index) {
        if (this.choose_index.indexOf(index) == -1) {
            this.choose_index.push(index);
        }
        else {
            this.choose_index.remove(index);
        }
        return true;
    };
    // ie设置
    ManagementModel.prototype.ieS = function () {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
        if (isIE) {
            var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
            reIE.test(userAgent);
            var fIEVersion = parseFloat(RegExp["$1"]);
            if (fIEVersion == 7) {
                return true;
            }
            else if (fIEVersion == 8) {
                return true;
            }
            else if (fIEVersion == 9) {
                return true;
            }
            else if (fIEVersion == 10) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    //用户管理全选
    ManagementModel.prototype.btn_choose_all = function (event) {
        var vm = this.viewModel();
        // debugger;
        if (this.ieS()) {
            if (event.srcElement.checked) {
                this.choose_index.removeAll();
                for (var i in vm.data.userList) {
                    this.choose_index.push(vm.data.userList[i].id);
                }
            }
            else {
                this.choose_index.removeAll();
            }
        }
        else {
            if (event.target.checked) {
                this.choose_index.removeAll();
                for (var i in vm.data.userList) {
                    this.choose_index.push(vm.data.userList[i].id);
                }
            }
            else {
                this.choose_index.removeAll();
            }
        }
        return true;
    };
    return ManagementModel;
}(KnockoutModel));
var GroupModel = /** @class */ (function (_super) {
    __extends(GroupModel, _super);
    function GroupModel(root) {
        var _this = _super.call(this, "/api/user/role/all", root, {
            name: ''
        }) || this;
        _this.select = ko.observable(''); //角色名搜索值
        ko.postbox.subscribe("fenzu", function (n) {
            _this.select('');
            _this.loadData();
        });
        return _this;
    }
    ///////////////////////////
    ////////////////////
    //////////////////////////分组管理模块
    //根据角色名查询
    GroupModel.prototype.changechoose = function () {
        var _this = this;
        //console.log("----------进来了------------");
        var name = this.select();
        if (name.trim() == "") {
            ajax.get("/api/user/role/all", { name: this.select() }).then(function (d) {
                _this.viewModel(d);
            });
        }
        else {
            ajax.get("/api/user/role/all", { name: this.select() }).then(function (d) {
                _this.viewModel(d);
            });
        }
    };
    //修改角色
    GroupModel.prototype.updateRole = function (htmle, id) {
        ajax.get("/api/user/role/getfolders", {
            userId: authorization.getUserId(),
            id: id.id
        })
            .then(function (d) { });
    };
    //删除角色
    GroupModel.prototype.delRole = function (htmle, id) {
        var _this = this;
        if (id.id != "") {
            var r = confirm("确认删除该标签");
            console.log(r);
            if (r == true) {
                ajax.deleteIt("/api/user/role/delrole", { id: id.id }).then(function (r) {
                    if (r.message == '该标签已经有用户在使用,不能删除') {
                        window.popBox.show(r.message);
                    }
                    else {
                        ajax.get("/api/user/role/all", { name: _this.select() }).then(function (d) {
                            if (d.status == '0') {
                                _this.viewModel(d);
                            }
                        });
                    }
                });
            }
            // else {
            //   ajax.get("/api/user/role/all", { name: this.select() }).then(d => {
            //     this.viewModel(d);
            //   });
            // }
        }
    };
    return GroupModel;
}(KnockoutModel));
var FrameworkModel = /** @class */ (function (_super) {
    __extends(FrameworkModel, _super);
    function FrameworkModel(root) {
        var _this = _super.call(this, "/api/org/showdepa", root, {}) || this;
        _this.tree1 = ko.observable(true);
        _this.tree2 = ko.observable(false); //编辑树
        _this.tree3 = ko.observable(false); //显示编辑后的树
        _this.editdepartmentUrl = ko.observable(''); //编辑树的url
        _this.addbm = ko.observable(0);
        _this.renyuan = ko.observable(0);
        _this.departmentUrl = ko.observable('');
        _this.adepartmentUrl = ko.observable(''); //编辑后的树
        _this.basePositionUrl = "/api/org/posts?pid="; // ran=Math.random()&
        _this.positionUrl = ko.observable();
        _this.basePositionUserUrl = "/api/org/userPost?pid=";
        _this.userList = ko.observableArray();
        _this.positionid = ko.observable(); //岗位id
        _this.baseDepartmentUserUrl = "/api/org/showuser?id=";
        _this.DepartmentUserList = ko.observableArray(); //部门下的人员
        _this.departmentId = ko.observable(); ////选中的部门id
        _this.departmentAndposition = ko.observable(); //部门岗位名称
        _this.chooseId = ko.observableArray(); //多选中的人员id
        _this.showKeep = ko.observable(false); //控制编辑显示隐藏
        _this.showEdit = ko.observable(true); //控制保存显示隐藏
        _this.isShowCheckbox = ko.observable(false); //显示多选框，默认不显示
        _this.departmentAllId = ko.observableArray(); //多选部门是否显示
        _this.depname = ko.observable(); //选中的部门
        _this.departmentList = ko.observableArray(); //编辑获取到的部门名称
        _this.showrenyuan = ko.observable(false); // 是否显示人员编辑
        _this.levelArr = ko.observableArray(['1', '2', '3', '4']);
        _this.levelModel = ko.observable();
        _this.AllR = ko.observableArray([]); //所有的角色标签
        _this.AllRole = ko.observableArray([]); //所有未选的角色标签
        _this.AllRCheck = ko.observableArray([]); //所有已选的角色标签
        _this.chooseRoleName = ko.observable(); //所选择的角色标签 名
        _this.chooseRoleId = ko.observableArray(); //所选择的角色标签 id
        _this.searchRole = ko.observable(''); //查询添加人员
        _this.leftRoleArr = ko.observableArray([]);
        _this.rightRoleArr = ko.observableArray([]);
        _this.isSelectChilen = ko.observable(true);
        _this.openModelType = ko.observable(false);
        _this.isfocus = ko.observable(false);
        ko.postbox.subscribe("jiagou", function (n) {
            console.log(0);
            _this.showEdit(true);
            _this.showKeep(false);
            _this.isShowCheckbox(false);
            _this.showrenyuan(false);
            // this.loadData();
            _this.departmentUrl('/api/org/showdepa');
        });
        return _this;
    }
    /////////////////////////
    ////////////////////////////////组织架构模块
    // 是否勾选子节点
    FrameworkModel.prototype.selectChilen = function () {
        console.log(this.isSelectChilen());
        ko.postbox.publish("isSelectChilen", this.isSelectChilen());
    };
    //同步按钮
    FrameworkModel.prototype.synchronization = function () {
        var t = confirm('是否确定同步');
        if (t == true) {
            window.popBox.show('同步数据可能需要一个半小时,请耐心等待，在此期间请勿关闭页面或进行其它操作');
            ajax.get('/api/orgs/Synchronize', {})
                .then(function (d) {
                window.popBox.show(d.message);
            });
        }
    };
    //编辑部门是否显示
    FrameworkModel.prototype.AddBM = function () {
        if (!this.showKeep()) {
            this.userList([]);
            // this.tree1(false);
            // this.tree2(true);
            // this.tree3(false)
            this.isSelectChilen(true); //是否选择子节点
            ko.postbox.publish("isSelectChilen", this.isSelectChilen());
            this.isShowCheckbox(true);
            this.showKeep(true);
            this.showEdit(false);
            this.departmentUrl('/api/org/departments'); //请求所有的部门
        }
    };
    //    buildChildNodes(TreeNode:any) {
    //     var children: Array<string> = TreeNode;
    //     if (!children.length) {
    //         for (TreeNode child : children) {
    //             buildChildNodes(child);
    //         }
    //         node.setChildren(children);
    //     }
    // }
    //   treeNode(data:any){
    //     for (var i in data) {
    //       console.log('i',i);
    //       console.log('datai',data[i].children);
    //       if (data[i].children) {
    //           console.log(data[i].children.id);
    //           break;
    //       } else {
    //           this.treeNode(data[i].children);
    //       }
    //   }
    // }
    //隐藏未勾选的部门
    FrameworkModel.prototype.keepSub = function (m, e) {
        var _this = this;
        var flag = confirm("是否保存编辑");
        if (flag) {
            if (this.showKeep()) {
                var depa = ComponentInstances["tree1"].getCheckedNode();
                // this.treeNode(depa);
                var list1 = [];
                for (var key in depa) {
                    list1.push([depa[key].id]); //泛型数组
                    this.departmentAllId(list1);
                }
                // if(this.departmentAllId()[0]!='0'){
                //   return window.popBox.show('必须勾选根节点！');
                // }
                //将选中的部门id发送并显示
                ajax.put("/api/org/departments", { id: this.departmentAllId() })
                    .then(function (d) {
                    if (d.message == "更改部门状态成功") {
                        // setTimeout(() => {
                        _this.departmentUrl('/api/org/showdepa'); //展示选中的部门
                        // }, 1000);
                        _this.isShowCheckbox(false);
                        _this.showKeep(false);
                        _this.tree1(true);
                        _this.tree2(false);
                        _this.showEdit(true);
                    }
                });
            }
        }
        else {
            // this.isShowCheckbox(false);
            // this.showKeep(false);
            // this.showEdit(true);
            // this.tree1(true);
            // this.tree2(false);
            // this.tree3(false)
            // this.departmentUrl('/api/org/showdepa');//展示选中的部门
        }
    };
    //点击选中部门
    FrameworkModel.prototype.onOrgChange = function (org) {
        var _this = this;
        console.log(0);
        if (org.id == '0') {
            org.isChecked = true;
        }
        else {
            org.isChecked = !org.isChecked;
        }
        if (this.isShowCheckbox() == false) {
            this.departmentId(org.id); //选中的部门id
            if (this.departmentId() == '0') {
                return window.popBox.show('根节点不可操作');
            }
            //this.positionUrl(this.basePositionUrl + org.id);
            // ajax.get(this.basePositionUserUrl+'gx111')
            // .then(d => this.userList(d.data));
            ajax.get('/api/org/showuser2', { departmentId: org.id }).then(function (d) { return _this.userList(d.data); });
            // this.positionUrl('/api/org/showuser2?departmentId='+org.id);
        }
    };
    //点击选中岗位
    FrameworkModel.prototype.onPositionChange = function (position) {
        //this.positionid(position.id);//选中的岗位id
        // ajax.get(this.basePositionUserUrl+position.id)
        // .then(d => this.userList(d.data));
    };
    //点击出现部门下的人员
    FrameworkModel.prototype.onUserChange = function (org) {
        var _this = this;
        ajax.get(this.baseDepartmentUserUrl + org.id)
            .then(function (d) {
            _this.DepartmentUserList(d.data);
        });
    };
    //人员编辑 保存
    FrameworkModel.prototype.showRY = function () {
        var _this = this;
        if (this.showrenyuan() == true) { //保存
            console.log(this.showrenyuan());
            var arr = [];
            for (var i in this.userList()) {
                if (this.userList()[i]['isChecked'] == true) {
                    arr.push(this.userList()[i]['id']);
                }
            }
            ajax.post('/api/org/saveuser', {
                user: arr,
                departmentId: this.departmentId()
            }).then(function (d) { return _this.userList(d.data); });
        }
        else { //编辑
            console.log(this.showrenyuan());
            ajax.get('/api/org/show', {
                departmentId: this.departmentId()
            }).then(function (d) { return _this.userList(d.data); });
        }
        this.showrenyuan(!this.showrenyuan());
    };
    FrameworkModel.prototype.openModel = function (data) {
        var _this = this;
        if (data.isChecked == false) {
            return window.popBox.show('该用户未分配大区');
        }
        this.openModelType(true);
        this.levelModel(data);
        ajax.get('/api/org/findrole', {
            userId: data.id
        }).then(function (d) {
            _this.chooseRoleId([]);
            _this.chooseRoleName('');
            _this.AllRole(d.data.Allrole);
            _this.AllRCheck(d.data.chooseRole);
            _this.AllR(d.data.Allrole.concat(d.data.chooseRole));
            console.log(_this.AllRCheck());
            for (var i in _this.AllRCheck()) {
                _this.chooseRoleId.push(_this.AllRCheck()[i].id);
                // if(this.chooseRoleName()==''){
                //   this.chooseRoleName(this.AllRCheck()[i].roleName);
                // }else{
                //   this.chooseRoleName(this.chooseRoleName()+','+this.AllRCheck()[i].roleName);
                // }
            }
        });
    };
    FrameworkModel.prototype.closeopenModelType = function () {
        this.openModelType(false);
        return true;
    };
    //光标进入人员部门下拉
    // onfocus(){
    //   this.isfocus(true);
    //   console.log(this.isfocus())
    // }
    // backSpace(e:any){
    //   console.log(typeof e.keyCode);
    //   if(e.keyCode==8){
    //     if(this.chooseRoleName()){
    //       let index= this.chooseRoleName().lastIndexOf(',')
    //       let str=this.chooseRoleName().substring(index+1);
    //       this.chooseRoleName(this.chooseRoleName().substring(0,index));
    //       let data= this.AllR().find(p=>p.roleName==str);
    //       this.AllRole.push(data);
    //       let dd= this.chooseRoleId().findIndex(p=>p==data.id);
    //       if( this.chooseRoleId().findIndex(p=>p==data.id)>-1){
    //         this.chooseRoleId().splice(this.chooseRoleId().findIndex(p=>p==data.id),1)
    //       }
    //     }
    //   }
    // }
    FrameworkModel.prototype.duble = function () {
        return true;
    };
    FrameworkModel.prototype.closeselect = function () {
        this.isfocus(false);
        console.log(this.isfocus());
        return true;
    };
    FrameworkModel.prototype.editSure = function (data) {
        var _this = this;
        // if(!this.chooseRoleId()){
        //   return window.popBox.show('请选择至少一个标签')
        // }
        // console.log(this.chooseRoleId())
        ajax.put('/api/org/updateuser', {
            list: this.chooseRoleId(),
            level: data.level,
            userId: data.id
        }).then(function (d) {
            window.popBox.show(d.message);
            _this.openModelType(false);
            ajax.get('/api/org/showuser2', { departmentId: _this.departmentId() }).then(function (d) { return _this.userList(d.data); });
        });
    };
    //选择添加一个角色
    // checkRole(id:any,name:any){
    //   for(let i in this.AllRole()){
    //      if(this.AllRole()[i].id==id){
    //         if(this.chooseRoleName()){
    //           this.chooseRoleName( this.chooseRoleName()+','+name);
    //         }else{
    //           this.chooseRoleName(name);
    //         }
    //         this.chooseRoleId.push(id);
    //         this.AllRole().splice(parseInt(i),1);
    //         console.log(this.AllRole())
    //      }
    //   }
    //   this.isfocus(false);
    // }
    //新增岗位
    // addRegion(rg: TreeNode) {
    //   if (rg.name == null || rg.name == '' || rg.name == undefined) {
    //     window.popBox.show('岗位名不能为空');
    //     return;
    //   }
    //   if (rg.name.length >= 10) {
    //     window.popBox.show('字符过长');
    //     return;
    //   }
    //   if (rg.pid == '0') {
    //     ajax.post('/api/org/posts', { name: rg.name, pid: this.departmentId(), position: '0' })
    //       .then(() => {
    //         this.positionUrl("/api/org/posts?pid=" + this.departmentId()+"&ran="+Math.random());
    //       })
    //   } else {
    //     ajax.post('/api/org/posts', { name: rg.name, pid: this.departmentId(), position: rg.pid })
    //       .then(() => {
    //        this.positionUrl("/api/org/posts?pid=" + this.departmentId() +"&ran="+ Math.random());
    //       })
    //   }
    // }
    //编辑岗位
    // editRegion(er: TreeNode) {
    //   if (er.name == null || er.name == "" || er.name == undefined) {
    //     window.popBox.show('名称不能为空');
    //     this.positionUrl("/api/org/posts?pid=" + this.departmentId()+"&ran=" + Math.random());
    //     return;
    //   }
    //   if (er.name.length >= 10) {
    //     window.popBox.show('字符过长');
    //     this.positionUrl("/api/org/posts?pid=" + this.departmentId() +"&ran="+ Math.random());
    //     return;
    //   }
    //   if (this.positionid() == "00-00-00-00-00-00-00-00-00-00-00") {
    //     window.popBox.show('根节点不能编辑');
    //     this.positionUrl("/api/org/posts?pid=" + this.departmentId() +"&ran="+ Math.random());
    //     return;
    //   }
    //   ajax.put('/api/org/posts', { name: er.name, id: er.id })
    // }
    //删除岗位
    // deleteRegion(dr: TreeNode) {
    //   if (this.positionid() == "00-00-00-00-00-00-00-00-00-00-00") {
    //     window.popBox.show('根节点不能删除');
    //     return;
    //   }
    //   ajax.get('/api/org/kids', {id: dr.id}).then((d) => {
    //     if (d.data==1) {
    //       window.popBox.show('请先删除子节点！');
    //       this.positionUrl("/api/org/posts?pid=" + this.departmentId() +"&ran="+ Math.random());
    //       return;
    //     } else if (d.data==0){
    //       ajax.deleteIt('/api/org/posts', { id: dr.id });
    //       ajax.get(this.basePositionUserUrl + 'gx111')//刷新人员
    //         .then(d => this.userList(d.data));
    //     }
    //   })
    // }
    //删除人员
    // deleteUser(m: any, e: any) {
    //   if (e.userId != "") {
    //     let r = confirm("确认删除该人员");
    //     if ((r == true)) {
    //       ajax.deleteIt("/api/org/userPost", { userId: e.userId, postId: this.positionid() })
    //         .then(() => {
    //           ajax.get(this.basePositionUserUrl + this.positionid())
    //             .then(d => this.userList(d.data));
    //         })
    //     }
    //   }
    // }
    FrameworkModel.prototype.deleteRole = function (id) {
        var _this = this;
        window.popBox.show("确定要删除该人员么", {
            isConfirmModal: true
        }).then(function () {
            ajax.deleteIt('/api/org/user', {
                userId: id
            }).then(function (d) {
                if (d) {
                    window.popBox.show(d.message).then(function () {
                        ajax.get('/api/org/showuser2', { departmentId: _this.departmentId() }).then(function (d) { return _this.userList(d.data); });
                    });
                }
            });
        });
    };
    FrameworkModel.prototype.startSearch = function () {
        var _this = this;
        console.log(this.searchRole());
        ajax.get('/api/ice/getuser', {
            name: this.searchRole()
        }).then(function (d) {
            _this.leftRoleArr(d.data);
        });
    };
    FrameworkModel.prototype.turnRole = function (data, index) {
        console.log(data);
        console.log(index);
        this.rightRoleArr.push(data);
        this.leftRoleArr.splice(index, 1);
    };
    FrameworkModel.prototype.deleterightRole = function (data, index) {
        console.log(data);
        console.log(index);
        this.leftRoleArr.push(data);
        this.rightRoleArr.splice(index, 1);
    };
    FrameworkModel.prototype.saverole = function () {
        var _this = this;
        if (this.rightRoleArr().length > 0) {
            var list = [];
            list = this.rightRoleArr().map(function (p) { return p.username; });
            console.log(list);
            ajax.post('/api/org/saveuser', {
                user: list
            }).then(function (d) {
                window.popBox.show(d.message).then(function () {
                    _this.renyuan(0);
                });
            });
        }
        else {
            window.popBox.show('未选择人员').then(function () {
                _this.renyuan(0);
            });
        }
    };
    FrameworkModel.prototype.RenYuan = function () {
        this.chooseId([]);
        this.rightRoleArr([]);
        if (this.renyuan() == 1) {
            this.renyuan(0);
        }
        else {
            this.searchRole('');
            this.renyuan(1);
        }
        return true;
    };
    //提交编辑的人员
    FrameworkModel.prototype.endSub = function (m, e) {
        var _this = this;
        if (this.chooseId() != null || this.chooseId() != undefined) {
            ajax.post('/api/org/userPost', {
                postId: this.positionid(),
                userId: this.chooseId()
            }).then(function () {
                ajax.get('/api/org/userPost', { pid: _this.positionid() })
                    .then(function (d) {
                    _this.userList(d.data); //部门下的人员
                });
                _this.chooseId([]);
            });
        }
        if (this.renyuan() == 1) {
            this.renyuan(0);
        }
        else {
            this.renyuan(1);
        }
    };
    //多选人员
    FrameworkModel.prototype.chooseUser = function (res, index) {
        if (this.chooseId.indexOf(index) == -1) {
            this.chooseId.push(index);
        }
        else {
            this.chooseId.remove(index);
        }
        return true;
    };
    //点击获取部门下的人员
    FrameworkModel.prototype.getDepartmentUser = function (m, e) {
        var _this = this;
        this.depname(e.dep);
        ajax.get('/api/org/old_user', { dname: this.depname() })
            .then(function (d) {
            _this.DepartmentUserList(d.data);
        });
    };
    //编辑人员弹框
    FrameworkModel.prototype.changeUser = function () {
        var _this = this;
        if (this.positionid() == '' || this.positionid() == null || this.positionid() == undefined) {
            // return window.popBox.show('请先选择岗位！');
        }
        else if (this.positionid() == '00-00-00-00-00-00-00-00-00-00-00') {
            window.popBox.show('根节点下不能添加人员');
            return;
        }
        else {
            ajax.get('/api/org/infos', { did: this.departmentId(), pid: this.positionid() })
                .then(function (d) {
                _this.departmentAndposition(d.data);
            });
            ajax.get('/api/org/old_dep', {})
                .then(function (d) {
                _this.departmentList(d.data);
            });
            if (this.renyuan() == 1) {
                this.renyuan(0);
            }
            else {
                this.renyuan(1);
            }
        }
    };
    return FrameworkModel;
}(KnockoutModel));
var TipModel = /** @class */ (function (_super) {
    __extends(TipModel, _super);
    function TipModel(root) {
        var _this = _super.call(this, "", root, {}) || this;
        _this.userId = ko.observable(authorization.getUserId()); //
        _this.leadurl = ko.observable('/api/logo/upload');
        _this.showAddImg = ko.observable(false); //管理图标
        _this.imgList = ko.observable([{ isCheck: ko.observable(true), isedit: ko.observable(true), isAdd: ko.observable(true), imgUrl: ko.observable(''), imgDescription: ko.observable(''), imgId: ko.observable(''), dataId: '' }]); //图标管理数组
        _this.tipTime = ko.observable(); //提醒时间
        ko.postbox.subscribe('tipsType', function (n) {
            _this.getImgList();
        });
        return _this;
    }
    // 上传图标
    TipModel.prototype.uploadImg = function (d, index, r) {
        this.imgList()[index].imgUrl(r.data[0].fileUrl);
        this.imgList()[index].imgId(r.data[0].fileId);
        // this.imgList()[index].iseditImg(false);
        this.imgList()[index].isCheck(false);
        this.imgList()[index].isedit(true);
        this.imgList()[index].isAdd(false);
    };
    // 获取图标列表
    TipModel.prototype.getImgList = function () {
        var _this = this;
        ajax.get('/api/logo').then(function (d) {
            _this.imgList([]);
            for (var n = 0; n < d.data.length; n++) {
                _this.imgList().push({ isCheck: ko.observable(true), isedit: ko.observable(false), isAdd: ko.observable(false), imgUrl: ko.observable(''), imgDescription: ko.observable(''), imgId: ko.observable(''), dataId: '' });
            }
            _this.imgList(_this.imgList());
            for (var i = 0; i < _this.imgList().length; i++) {
                _this.imgList()[i].isedit(false);
                _this.imgList()[i].isAdd(false);
                _this.imgList()[i].isCheck(true);
                _this.imgList()[i].imgUrl(d.data[i].url);
                _this.imgList()[i].imgDescription(d.data[i].name);
                _this.imgList()[i].imgId(d.data[i].fileId);
                _this.imgList()[i].dataId = d.data[i].id;
                // this.imgList()[i].iseditImg(false);
            }
        });
    };
    // 确定上传图标以及说明
    TipModel.prototype.sureUploadImg = function (index, d) {
        var _this = this;
        if (!this.imgList()[index].imgUrl()) {
            return window.popBox.show('未上传图片');
        }
        if (!this.imgList()[index].imgDescription()) {
            return window.popBox.show('请填写图标说明');
        }
        var dataId = '0000';
        if (d.dataId != '') {
            dataId = d.dataId;
        }
        ajax.post('/api/logo/' + dataId, {
            name: this.imgList()[index].imgDescription(),
            url: this.imgList()[index].imgUrl(),
            fileId: this.imgList()[index].imgId(),
            userId: this.userId(),
            remark: '',
        }).then(function (d) {
            _this.getImgList();
        }).catch(function (res) {
            return window.popBox.show(res.message);
        });
    };
    // 新增一条
    TipModel.prototype.addOneImg = function () {
        for (var i = 0; i < this.imgList().length; i++) {
            if (this.imgList()[i].isAdd() || this.imgList()[i].isedit()) {
                return;
            }
        }
        this.imgList().unshift({ isCheck: ko.observable(false), isedit: ko.observable(false), isAdd: ko.observable(true), imgUrl: ko.observable(''), imgDescription: ko.observable(''), imgId: ko.observable(''), dataId: '' });
        this.imgList(this.imgList());
    };
    // 取消新增
    TipModel.prototype.delAdd = function (d, r) {
        this.imgList().splice(d, 1);
        this.imgList(this.imgList());
        this.getImgList();
    };
    // 删除一条
    TipModel.prototype.deleteOneImg = function (index, d) {
        var _this = this;
        // console.log(d,index);
        for (var i = 0; i < this.imgList().length; i++) {
            if (this.imgList()[i].isedit() || this.imgList()[i].isAdd()) {
                return window.popBox.show('请先关闭新增或编辑');
            }
        }
        window.popBox.show('确认删除该图标', { showFooter: true, isConfirmModal: true }).then(function (res) {
            ajax.deleteIt('/api/logo/' + d.dataId).then(function (d) {
                if (d.status == '0') {
                    _this.imgList().splice(index, 1);
                    window.popBox.show('删除成功');
                    _this.getImgList();
                }
            }).catch(function (m) {
                return window.popBox.show(m.message);
            });
        });
    };
    // 编辑一条
    TipModel.prototype.editOneImg = function (index, d) {
        // console.log(d, index);
        for (var i = 0; i < this.imgList().length; i++) {
            if (this.imgList()[i].isedit() || this.imgList()[i].isAdd()) {
                return;
            }
        }
        this.imgList()[index].isCheck(false);
        this.imgList()[index].isedit(true);
        this.imgList()[index].isAdd(false);
    };
    // 取消编辑
    TipModel.prototype.quickEdit = function (d, r) {
        this.imgList()[d].isCheck(true);
        this.imgList()[d].isedit(false);
        this.imgList()[d].isAdd(false);
        this.getImgList();
    };
    return TipModel;
}(KnockoutModel));
var lableModel = /** @class */ (function (_super) {
    __extends(lableModel, _super);
    function lableModel(root) {
        var _this = _super.call(this, "", root, {}) || this;
        _this.showAddImg = ko.observable(false); //管理标签
        _this.lableList = ko.observable([{ isedit: ko.observable(false), isAdd: ko.observable(false), ischeck: ko.observable(true), lableColor: ko.observable(''), lableDescription: ko.observable(''), lableId: ko.observable(''), dataId: '' }]); //图标管理数组
        _this.tipTime = ko.observable(); //提醒时间
        ko.postbox.subscribe('labelMaintenance', function (n) {
            _this.getLableList();
        });
        return _this;
    }
    // 获取标签列表
    lableModel.prototype.getLableList = function () {
        var _this = this;
        ajax.get('/api/label').then(function (d) {
            console.log(d);
            _this.lableList([]);
            for (var n = 0; n < d.data.length; n++) {
                _this.lableList().push({ isedit: ko.observable(false), isAdd: ko.observable(false), ischeck: ko.observable(true), lableColor: ko.observable(''), lableDescription: ko.observable(''), lableId: ko.observable(''), dataId: '' });
            }
            _this.lableList(_this.lableList());
            for (var i = 0; i < _this.lableList().length; i++) {
                _this.lableList()[i].isedit(false);
                _this.lableList()[i].isAdd(false);
                _this.lableList()[i].lableDescription(d.data[i].name);
                _this.lableList()[i].lableColor(d.data[i].colour);
                _this.lableList()[i].dataId = d.data[i].id;
                _this.lableList()[i].ischeck(true);
            }
        });
    };
    // 提交标签
    lableModel.prototype.sureUploadLable = function (index, d) {
        var _this = this;
        if (!this.lableList()[index].lableColor()) {
            return window.popBox.show('请填写颜色');
        }
        if (this.lableList()[index].lableColor().substr(0, 1) != '#') {
            return window.popBox.show('颜色值错误');
        }
        var re = /[a-fA-F0-9]{6,16}/;
        var str = this.lableList()[index].lableColor().replace('#', ' ').trim();
        if (str.length != 6) {
            return window.popBox.show('颜色值错误');
        }
        if (!re.test(str)) {
            return window.popBox.show('颜色值错误');
        }
        if (str == 'ffffff' || str == 'FFFFFF') {
            return window.popBox.show('颜色值不能为白色');
        }
        if (!this.lableList()[index].lableDescription()) {
            return window.popBox.show('请填写标签说明');
        }
        var dataId = '0000';
        if (d.dataId != '') {
            dataId = d.dataId;
        }
        ajax.post('/api/label/' + dataId, {
            name: this.lableList()[index].lableDescription(),
            colour: this.lableList()[index].lableColor(),
            userId: authorization.getUserId()
        }).then(function (d) {
            if (d.status == '0') {
                window.popBox.show('提交成功').then(function () {
                    _this.getLableList();
                });
            }
            else {
            }
        }).catch(function (res) {
            window.popBox.show(res.message);
        });
    };
    // 新增
    lableModel.prototype.addOne = function () {
        for (var i = 0; i < this.lableList().length; i++) {
            if (this.lableList()[i].isAdd() || this.lableList()[i].isedit()) {
                return;
            }
        }
        this.lableList().unshift({ isedit: ko.observable(false), isAdd: ko.observable(true), ischeck: ko.observable(false), lableColor: ko.observable(''), lableDescription: ko.observable(''), lableId: ko.observable(''), dataId: '' });
        this.lableList(this.lableList());
    };
    // 取消新增
    lableModel.prototype.delAdd = function (d, r) {
        this.lableList().splice(d, 1);
        this.lableList(this.lableList());
        this.getLableList();
    };
    // 删除
    lableModel.prototype.deleteOne = function (index, d) {
        var _this = this;
        for (var i = 0; i < this.lableList().length; i++) {
            if (this.lableList()[i].isedit() || this.lableList()[i].isAdd()) {
                return window.popBox.show('请先关闭新增或编辑');
            }
        }
        window.popBox.show('确认删除该标签', { showFooter: true, isConfirmModal: true }).then(function (res) {
            ajax.deleteIt('/api/label/' + d.dataId).then(function (d) {
                _this.lableList().splice(index, 1);
                _this.getLableList();
            }).catch(function (r) {
                return window.popBox.show("有项目使用该标签,无法删除");
            });
        });
    };
    // 编辑
    lableModel.prototype.editOne = function (index, d) {
        for (var i = 0; i < this.lableList().length; i++) {
            if (this.lableList()[i].isAdd() || this.lableList()[i].isedit()) {
                return;
            }
        }
        this.lableList()[index].ischeck(false);
        this.lableList()[index].isedit(true);
        this.lableList()[index].isAdd(false);
    };
    // 取消编辑
    lableModel.prototype.quickEdit = function (d, r) {
        this.lableList()[d].ischeck(true);
        this.lableList()[d].isedit(false);
        this.lableList()[d].isAdd(false);
        this.getLableList();
    };
    lableModel.prototype.setTextColor = function (d) {
        // jscolor
        // let cc=new jscolor('');
        // console.log(jscolor);
        // document.getElementsByTagName('body')[0].style.color = '#' + jscolor.toString()
    };
    return lableModel;
}(KnockoutModel));
var mModel = /** @class */ (function (_super) {
    __extends(mModel, _super);
    function mModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    mModel.prototype.init = function () {
        var _this = this;
        this.sm = new SystemsetupModel(this.container.querySelector(".Myproject"));
        this.lm = new LogModel(this.container.querySelector("#log"));
        this.tm = new TypeModel(this.container.querySelector("#type"));
        this.um = new ManagementModel(this.container.querySelector("#user"));
        this.gm = new GroupModel(this.container.querySelector("#group"));
        this.fm = new FrameworkModel(this.container.querySelector("#framework"));
        this.pm = new PerformanceModel(this.container.querySelector('#lookYearOfPerformance-vm'));
        this.tipm = new TipModel(this.container.querySelector('#tips'));
        this.lb = new lableModel(this.container.querySelector('#lable'));
        this.sm.bind();
        this.fm.bind();
        this.tipm.bind();
        this.lb.bind();
        this.tm.chooseType = function (type) {
            _this.sm.isShowPerformance(type);
            _this.pm.isShowPerformance(type);
            _this.pm.load();
        };
        this.pm.chooseType = function (type) {
            _this.sm.isShowPerformance(type);
            _this.pm.isShowPerformance(type);
            _this.tm.isShowPerformance(type);
        };
    };
    mModel.prototype.update = function (arg) {
        var _this = this;
        // ajax.get("/api/menu/systemSetting", {uid:authorization.getUserId() })
        // .then(() => {}); //权限url拦截
        this.fm.chooseRoleName(undefined);
        this.lm.data.pageIndex = 1;
        this.lm.data.condition = "";
        this.lm.data.type = 0;
        this.gm.select("");
        this.lm.load();
        this.tm.getArea(); //新增面积
        this.fm.isSelectChilen(true);
        // this.sm.xitong(1)
        //系统日志
        ajax.post('/api/log/add', { userId: authorization.getUserId(), logMessage: "系统设置" });
        //分组角色
        ajax.get("/api/user/role/all", { name: this.gm.select() })
            .then(function (d) {
            _this.gm.viewModel(d);
        });
        //       兼容ie11以下没有find方法
        // 没有该方法时,自定义
        // if (!Array.prototype.find) {
        //   Array.prototype.find = function (callback: any) {
        //     return callback && (this.filter(callback) || [])[0];
        //   };
        // }
        return Promise.resolve();
    };
    mModel.prototype.onInitComplete = function () {
        // 兼容ie数组没有findIndex方法
        if (!Array.prototype.findIndex) {
            Object.defineProperty(Array.prototype, 'findIndex', {
                value: function (predicate) {
                    // 1. Let O be ? ToObject(this value).
                    if (this == null) {
                        throw new TypeError('"this" is null or not defined');
                    }
                    var o = Object(this);
                    // 2. Let len be ? ToLength(? Get(O, "length")).
                    var len = o.length >>> 0;
                    // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                    if (typeof predicate !== 'function') {
                        throw new TypeError('predicate must be a function');
                    }
                    // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                    var thisArg = arguments[1];
                    // 5. Let k be 0.
                    var k = 0;
                    // 6. Repeat, while k < len
                    while (k < len) {
                        // a. Let Pk be ! ToString(k).
                        // b. Let kValue be ? Get(O, Pk).
                        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                        // d. If testResult is true, return k.
                        var kValue = o[k];
                        if (predicate.call(thisArg, kValue, k, o)) {
                            return k;
                        }
                        // e. Increase k by 1.
                        k++;
                    }
                    // 7. Return -1.
                    return -1;
                }
            });
        }
    };
    return mModel;
}(Page));
export default mModel;
